module.exports = __webpack_public_path__ + "static/media/prenda1-min.516dc79e.jpg";